(() => {
  'use strict';
  const context = JSON.parse(document.getElementById('elise-context').textContent);
  const meta = window.ELISE_CATALOG_META;
  const root = context.root.endsWith('/') ? context.root : context.root + '/';
  context.root = root;
  window.ELISE_CONTEXT = context;
  const errorBox = document.getElementById('elise-load-error');
  const preview = new URLSearchParams(location.search).get('preview_theme_id');
  const prefix = 'elise-page-catalog-v3-' + context.themeId + '-' + root + '-';
  const read = (key, fallback) => { try { return JSON.parse(sessionStorage.getItem(key)) || fallback; } catch { return fallback; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch {} };
  const products = [], groups = [];
  let running = false, collectionRequest;
  function normalize(p) {
    const text = (p.type + ' ' + p.name).toLocaleLowerCase('fr');
    const type = /parure|jewelry set|jewellery set|ensemble|necklace.{0,10}bracelet/.test(text) ? 'Sets'
      : /earring|oreille/.test(text) ? 'Earrings' : /necklace|collier|pendant|pendentif/.test(text) ? 'Necklaces'
      : /bracelet|bangle/.test(text) ? 'Bracelets' : /ring|bague/.test(text) ? 'Rings' : 'Jewelry';
    const existing = meta.products[p.handle];
    return {...p, id: existing?.id || p.id, name: existing?.name || p.name, type, variantsCount: p.variants.length};
  }
  function merge(items) {
    const map = new Map(products.map(p => [p.shopifyId, p]));
    items.filter(Boolean).forEach(p => map.set(p.shopifyId, normalize(p)));
    if (context.selected) map.set(context.selected.shopifyId, normalize(context.selected));
    const order = p => { const i = meta.featured.indexOf(p.handle); return i < 0 ? 999 : i; };
    products.splice(0, products.length, ...[...map.values()].sort((a,b) => order(a) - order(b)));
    groups.forEach(c => { c.products = products.filter(p => p.collectionHandles.includes(c.id)).map(p => p.id); });
  }
  async function request(path) {
    const url = new URL(path, location.origin);
    if (url.origin !== location.origin) throw new Error('Invalid catalogue origin');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    const response = await fetch(url, {credentials: 'same-origin', signal: AbortSignal.timeout(20000)});
    if (!response.ok) throw new Error('Catalogue unavailable');
    return response.json();
  }
  async function loadCollection(handle) {
    const key = prefix + handle, cached = read(key, null);
    if (cached && Date.now() - cached.time < 60000 && Array.isArray(cached.products)) return cached.products;
    const items = [], visited = new Set();
    let path = root + 'collections/' + encodeURIComponent(handle) + '?view=elise-catalog';
    while (path) {
      const url = new URL(path, location.origin);
      url.searchParams.set('view', 'elise-catalog');
      if (visited.has(url.href)) throw new Error('Repeated catalogue page');
      visited.add(url.href);
      const data = await request(url.href);
      if (!Array.isArray(data.products)) throw new Error('Invalid catalogue');
      items.push(...data.products);
      path = data.next;
    }
    write(key, {time: Date.now(), products: items});
    return items;
  }
  context.collectionReady = context.page !== 'collection' || context.seed.length >= context.collectionCount;
  context.ensureCollection = () => {
    if (context.collectionReady) return Promise.resolve();
    if (!collectionRequest) collectionRequest = loadCollection(context.handle || 'all').then(items => {
      merge(items);
      context.collectionProductIds = items.map(p => normalize(p).id);
      context.collectionCount = items.length;
      context.collectionReady = true;
      document.dispatchEvent(new CustomEvent('elise:collection-ready'));
    }).catch(error => { collectionRequest = null; throw error; });
    return collectionRequest;
  };
  async function restoreSelection() {
    const cart = read('elise-shopify-cart', []), saved = read('elise-shopify-saved', []);
    const ids = [...new Set([...cart.map(item => item.id), ...saved])];
    const remembered = read('elise-product-handles', {});
    const legacy = read('elise-live-catalog-v2-' + root + '-' + (preview || 'store'), {}).products || [];
    const byId = new Map(Object.entries(meta.products).map(([handle,p]) => [p.id, handle]));
    legacy.forEach(p => byId.set(normalize(p).id, p.handle));
    const missing = ids.filter(id => !products.some(p => p.id === id));
    for (let i = 0; i < missing.length; i += 4) {
      const restored = await Promise.all(missing.slice(i,i+4).map(async id => {
        const handle = remembered[id] || byId.get(id);
        if (!handle) throw new Error('Selection product could not be restored');
        const p = await request(root + 'products/' + encodeURIComponent(handle) + '?view=elise-data');
        if (p && !Array.isArray(p.variants)) throw new Error('Invalid selection product');
        return p;
      }));
      merge(restored);
    }
  }
  async function start() {
    if (running) return;
    running = true;
    errorBox.hidden = true;
    try {
      merge([...context.featured, ...context.seed]);
      context.collectionProductIds = context.seed.map(p => normalize(p).id);
      await restoreSelection();
      if (!products.length) return;
      groups.splice(0, groups.length, ...context.collections.map(c => {
        const members = products.filter(p => p.collectionHandles.includes(c.id));
        const existing = meta.collections[c.id];
        return {...c, title: existing?.title || c.title, description: existing?.description || '', image: c.image || members[0]?.image || '', products: members.map(p => p.id)};
      }).filter(c => c.count > 0));
      const order = Object.keys(meta.collections);
      groups.sort((a,b) => (order.indexOf(a.id) < 0 ? 999 : order.indexOf(a.id)) - (order.indexOf(b.id) < 0 ? 999 : order.indexOf(b.id)));
      window.ELISE_PRODUCTS = products;
      window.ELISE_COLLECTIONS = groups;
      await new Promise((resolve,reject) => {
        const script = document.createElement('script');
        script.src = context.appUrl;
        script.onload = resolve;
        script.onerror = reject;
        document.body.append(script);
      });
      if (!context.collectionReady) setTimeout(() => context.ensureCollection().catch(() => {}), 0);
    } catch (error) {
      errorBox.replaceChildren();
      const message = document.createElement('p');
      message.textContent = context.copy.loadError;
      const retry = document.createElement('button');
      retry.className = 'btn light';
      retry.textContent = context.copy.retry;
      retry.addEventListener('click', start);
      errorBox.append(message, retry);
      errorBox.hidden = false;
      console.error('Amélie catalogue:', error);
    } finally { running = false; }
  }
  start();
})();
